import formName from 'constants/formName'
import { actions } from 'data'
import { call, put } from 'redux-saga/effects'
import { selectTier } from 'services/api/kyc'

import { goToStep } from './common'

export default function* welcomeStep() {
  yield put(actions.form.change(formName.TIER_TWO, 'loading', false))
  yield call(selectTier, 2)
  yield call(goToStep, 'preIdv')
}
